const Templates = [
    {
        "Name": "Logo Left Aligned",
        "IsDefault": true,
        "Type": "consignments",
        "Document": {
            "Config": {
                "Style": {
                    "paddingTop": "20px",
                    "paddingBottom": "40px",
                    "paddingLeft": "40px",
                    "paddingRight": "40px"
                },
                "PDF": {
                    "pageMarginTop": "10",
                    "pageMarginBottom": "10",
                    "pageMarginLeft": "10",
                    "pageMarginRight": "10",
                    "footer": true
                }
            },
            "Id": "documentSettings"
        },
        "Blocks": [
            {
                "Id": "columnsTwo-default",
                "Type": "columnsTwo",
                "Config": {
                    "Block": {
                        "col1_width": "66",
                        "col1_verticalAlign": "top",
                        "col1_collapseIfEmpty": false,
                        "col2_width": "",
                        "col2_verticalAlign": "top",
                        "col2_collapseIfEmpty": false
                    },
                    "Style": {
                        "paddingTop": "20px",
                        "paddingBottom": "20px",
                        "minHeight": "50px"
                    }
                },
                "Columns": [
                    [
                        {
                            "Id": "logo-default",
                            "Type": "logo",
                            "Config": {
                                "Block": {
                                    "maxWidth": "100%",
                                    "maxHeight": "75px"
                                },
                                "Style": {
                                    "textAlign": "left"
                                }
                            }
                        }
                    ],
                    [
                        {
                            "Id": "companyAddress-default",
                            "Type": "companyAddress",
                            "Config": {
                                "Block": {
                                    "styleCompany": "header",
                                    "colorCompany": "#434343",
                                    "fontSizeCompany": "16px",
                                    "lineHeightCompany": "22px",
                                    "styleAddress": "body",
                                    "colorAddress": "#949494",
                                    "fontSizeAddress": "12px",
                                    "lineHeightAddress": "18px"
                                },
                                "Includes": {
                                    "Company": true,
                                    "Phone": true,
                                    "Website": true
                                },
                                "Style": {
                                    "paddingBottom": "6px",
                                    "textAlign": "right"
                                }
                            }
                        }
                    ]
                ]
            },
            {
                "Id": "separator-default",
                "Type": "separator",
                "Config": {
                    "Block": {
                        "color": "#e9e9e9"
                    },
                    "Style": {
                        "paddingTop": "20px",
                        "paddingBottom": "20px"
                    }
                }
            },
            {
                "Id": "title-default",
                "Type": "title",
                "Config": {
                    "Block": {
                        "style": "header",
                        "fontSize": "18px",
                        "lineHeight": "23px"
                    },
                    "Style": {
                        "paddingTop": "20px",
                        "textAlign": "left"
                    }
                }
            },
            {
                "Id": "termDate-default",
                "Type": "termDate",
                "Config": {
                    "Block": {
                        "style": "header",
                        "fontSize": "18px",
                        "lineHeight": "23px"
                    },
                    "Style": {
                        "paddingBottom": "",
                        "textAlign": "left"
                    }
                }
            },
            {
                "Id": "address-default",
                "Type": "address",
                "Config": {
                    "Block": {
                        "style": "header",
                        "fontSize": "18px",
                        "lineHeight": "23px"
                    },
                    "Includes": {
                        "ContactName": true,
                        "SpouseName": false,
                        "Phone": true
                    },
                    "Style": {
                        "paddingBottom": "20px",
                        "textAlign": "left",
                        "paddingTop": "20px"
                    }
                }
            },
            {
                "Id": "itemContainer-default",
                "Type": "itemContainer",
                "Config": {
                    "Block": {
                        "col1_width": "100"
                    },
                    "Style": {}
                },
                "Columns": [
                    [
                        {
                            "Id": "columnsFour-default",
                            "Type": "columnsFour",
                            "Config": {
                                "Block": {
                                    "col1_width": "190px",
                                    "col1_verticalAlign": "top",
                                    "col1_collapseIfEmpty": true,
                                    "col2_width": "",
                                    "col2_verticalAlign": "top",
                                    "col2_collapseIfEmpty": false,
                                    "col3_width": "95px",
                                    "col3_verticalAlign": "top",
                                    "col3_collapseIfEmpty": true,
                                    "col4_width": "125px",
                                    "col4_verticalAlign": "top",
                                    "col4_collapseIfEmpty": true
                                },
                                "Header": {
                                    "renderHeaderOnlyFirst": true,
                                    "col1_style": "body",
                                    "col1_textAlign": "left",
                                    "col2_style": "body",
                                    "col2_textAlign": "left",
                                    "col3_style": "header",
                                    "col3_textAlign": "right",
                                    "col4_style": "header",
                                    "col4_textAlign": "right",
                                    "col4_textLabel": "Consignment Cost",
                                    "col4_fontSize": "15px",
                                    "col4_lineHeight": "19px",
                                    "col3_fontSize": "15px",
                                    "col3_lineHeight": "19px",
                                    "col3_textLabel": "Retail Price",
                                    "lineSpacing": "20px"
                                },
                                "Style": {
                                    "paddingBottom": "24px"
                                }
                            },
                            "Columns": [
                                [
                                    {
                                        "Id": "itemImage-default",
                                        "Type": "itemImage",
                                        "Config": {
                                            "Block": {
                                                "maxWidth": "163px",
                                                "maxHeight": "199px"
                                            },
                                            "Visibility": {
                                                "Image": true
                                            },
                                            "Style": {
                                                "textAlign": "center"
                                            }
                                        }
                                    }
                                ],
                                [
                                    {
                                        "Id": "itemArtist-default",
                                        "Type": "itemArtist",
                                        "Config": {
                                            "Block": {
                                                "style": "body",
                                                "fontSize": "14px",
                                                "lineHeight": "19px"
                                            },
                                            "Style": {
                                                "textAlign": "left"
                                            }
                                        }
                                    },
                                    {
                                        "Id": "itemTitle-default",
                                        "Type": "itemTitle",
                                        "Config": {
                                            "Block": {
                                                "style": "body",
                                                "fontSize": "14px",
                                                "lineHeight": "19px"
                                            },
                                            "Includes": {
                                                "Edition": true,
                                                "Date": true
                                            },
                                            "Style": {
                                                "textAlign": "left"
                                            }
                                        }
                                    },
                                    {
                                        "Id": "itemMedium-default",
                                        "Type": "itemMedium",
                                        "Config": {
                                            "Block": {
                                                "style": "body",
                                                "fontSize": "14px",
                                                "lineHeight": "19px"
                                            },
                                            "Visibility": {
                                                "Medium": true
                                            },
                                            "Style": {
                                                "textAlign": "left"
                                            }
                                        }
                                    },
                                    {
                                        "Id": "itemDimensions-default",
                                        "Type": "itemDimensions",
                                        "Config": {
                                            "Block": {
                                                "style": "body",
                                                "fontSize": "14px",
                                                "lineHeight": "19px"
                                            },
                                            "Visibility": {
                                                "Dimensions": true
                                            },
                                            "Style": {
                                                "textAlign": "left"
                                            }
                                        }
                                    },
                                    {
                                        "Id": "itemNumber-default",
                                        "Type": "itemNumber",
                                        "Config": {
                                            "Block": {
                                                "style": "body",
                                                "fontSize": "14px",
                                                "lineHeight": "19px",
                                                "textLabel": "Inventory #: "
                                            },
                                            "Visibility": {
                                                "Number": true
                                            },
                                            "Style": {
                                                "textAlign": "left"
                                            }
                                        }
                                    },
                                    {
                                        "Id": "itemSKU-default",
                                        "Type": "itemSKU",
                                        "Config": {
                                            "Block": {
                                                "style": "body",
                                                "fontSize": "14px",
                                                "lineHeight": "19px",
                                                "textLabel": "SKU: "
                                            },
                                            "Visibility": {
                                                "SKU": true
                                            },
                                            "Style": {
                                                "textAlign": "left"
                                            }
                                        }
                                    },
                                    {
                                        "Id": "itemLocation-default",
                                        "Type": "itemLocation",
                                        "Config": {
                                            "Block": {
                                                "style": "body",
                                                "fontSize": "14px",
                                                "lineHeight": "19px"
                                            },
                                            "Visibility": {
                                                "Location": true
                                            },
                                            "Style": {
                                                "textAlign": "left"
                                            }
                                        }
                                    },
                                    {
                                        "Id": "itemAcquisitionDate-default",
                                        "Type": "itemAcquisitionDate",
                                        "Config": {
                                            "Block": {
                                                "style": "body",
                                                "fontSize": "14px",
                                                "lineHeight": "19px",
                                                "textLabel": "Acquisition Date: "
                                            },
                                            "Visibility": {
                                                "AcquisitionDate": true
                                            },
                                            "Style": {
                                                "textAlign": "left"
                                            }
                                        }
                                    }
                                ],
                                [
                                    {
                                        "Id": "itemPrice-default",
                                        "Type": "itemPrice",
                                        "Config": {
                                            "Block": {
                                                "style": "body",
                                                "fontSize": "15px",
                                                "lineHeight": "19px"
                                            },
                                            "Visibility": {
                                                "Price": true
                                            },
                                            "Style": {
                                                "textAlign": "right"
                                            },
                                            "Format": {}
                                        }
                                    }
                                ],
                                [
                                    {
                                        "Id": "itemConsignmentCost-default",
                                        "Type": "itemConsignmentCost",
                                        "Config": {
                                            "Block": {
                                                "style": "body",
                                                "fontSize": "15px",
                                                "lineHeight": "19px"
                                            },
                                            "Visibility": {
                                                "ConsignmentCost": true
                                            },
                                            "Style": {
                                                "textAlign": "right"
                                            },
                                            "Format": {}
                                        }
                                    }
                                ]
                            ]
                        }
                    ]
                ]
            },
            {
                "Id": "totals-default",
                "Type": "totals",
                "Config": {
                    "Block": {
                        "displayType": "columns",
                        "styleDescription": "header",
                        "fontSizeDescription": "15px",
                        "lineHeightDescription": "19px",
                        "fontWeightDescription": "bold",
                        "textDescription": "Totals",
                        "styleLabel": "header",
                        "fontSizeLabel": "15px",
                        "lineHeightLabel": "19px",
                        "styleValue": "header",
                        "fontSizeValue": "15px",
                        "lineHeightValue": "19px",
                        "columnWidthLabel": "105px",
                        "textAlignLabel": "right",
                        "columnWidthValue": "125px",
                        "textAlignValue": "right"
                    },
                    "Includes": {
                        "RetailTotal": true,
                        "ConsignmentTotal": true
                    },
                    "Style": {
                        "textAlign": "right"
                    },
                    "Format": {
                        "currencyFormatRetail": "[CurrencySymbol]1[ThousandsSep]000[DecimalSep]00",
                        "currencyFormatConsignment": "[CurrencySymbol]1[ThousandsSep]000[DecimalSep]00"
                    }
                }
            },
            {
                "Id": "terms-default",
                "Type": "terms",
                "Config": {
                    "Block": {
                        "style": "body"
                    },
                    "Style": {
                        "textAlign": "left"
                    }
                }
            },
            {
                "Id": "columnsThree-default",
                "Type": "columnsThree",
                "Config": {
                    "Block": {
                        "col1_width": "45%",
                        "col1_verticalAlign": "top",
                        "col1_collapseIfEmpty": false,
                        "col2_width": "5%",
                        "col2_verticalAlign": "top",
                        "col2_collapseIfEmpty": false,
                        "col3_width": "45%",
                        "col3_verticalAlign": "top",
                        "col3_collapseIfEmpty": false
                    },
                    "Style": {
                        "paddingTop": "20px",
                        "paddingBottom": "20px",
                        "minHeight": "50px"
                    }
                },
                "Columns": [
                    [
                        {
                            "Id": "signature-recipient-default",
                            "Type": "signature",
                            "Config": {
                                "Block": {
                                    "signatureType": "recipient",
                                    "styleDate": "body",
                                    "fontSizeDate": "15px",
                                    "lineHeightDate": "19px",
                                    "fontStyleDate": "normal",
                                    "textTransformDate": "none",
                                    "lineSpacingDate": "4px",
                                    "styleNameLabel": "body",
                                    "fontSizeNameLabel": "15px",
                                    "lineHeightNameLabel": "19px",
                                    "fontStyleNameLabel": "normal",
                                    "textTransformNameLabel": "none",
                                    "lineSpacingNameLabel": "4px",
                                    "styleCompanyLabel": "body",
                                    "fontSizeCompanyLabel": "15px",
                                    "lineHeightCompanyLabel": "19px",
                                    "fontStyleCompanyLabel": "normal",
                                    "textTransformCompanyLabel": "none",
                                    "lineSpacingCompanyLabel": "4px",
                                    "textDateLabel": "Date",
                                    "styleDateLabel": "body",
                                    "fontSizeDateLabel": "15px",
                                    "lineHeightDateLabel": "19px",
                                    "fontStyleDateLabel": "normal",
                                    "lineSpacingDateLabel": "4px"
                                },
                                "Includes": {
                                    "DateLabel": true,
                                    "Date": true,
                                    "Company": true
                                },
                                "Style": {
                                    "paddingTop": "5px",
                                    "paddingBottom": "4px"
                                }
                            }
                        }
                    ],
                    [],
                    [
                        {
                            "Id": "signature-sender-default",
                            "Type": "signature",
                            "Config": {
                                "Block": {
                                    "signatureType": "sender",
                                    "styleDate": "body",
                                    "fontSizeDate": "15px",
                                    "lineHeightDate": "19px",
                                    "fontStyleDate": "normal",
                                    "textTransformDate": "none",
                                    "lineSpacingDate": "4px",
                                    "styleNameLabel": "body",
                                    "fontSizeNameLabel": "15px",
                                    "lineHeightNameLabel": "19px",
                                    "fontStyleNameLabel": "normal",
                                    "textTransformNameLabel": "none",
                                    "lineSpacingNameLabel": "4px",
                                    "styleCompanyLabel": "body",
                                    "fontSizeCompanyLabel": "15px",
                                    "lineHeightCompanyLabel": "19px",
                                    "fontStyleCompanyLabel": "normal",
                                    "textTransformCompanyLabel": "none",
                                    "lineSpacingCompanyLabel": "8px",
                                    "textDateLabel": "Date",
                                    "styleDateLabel": "body",
                                    "fontSizeDateLabel": "15px",
                                    "lineHeightDateLabel": "19px",
                                    "fontStyleDateLabel": "normal",
                                    "lineSpacingDateLabel": "4px"
                                },
                                "Includes": {
                                    "DateLabel": true,
                                    "Date": true,
                                    "Company": true
                                },
                                "Style": {
                                    "paddingTop": "5px",
                                    "paddingBottom": "4px"
                                }
                            }
                        }
                    ]
                ]
            }
        ]
    },
    {
        "Name": "Logo Right Aligned",
        "IsDefault": false,
        "Type": "consignments",
        "Document": {
            "Config": {
                "Style": {
                    "paddingTop": "20px",
                    "paddingBottom": "40px",
                    "paddingLeft": "40px",
                    "paddingRight": "40px"
                },
                "PDF": {
                    "pageMarginTop": "10",
                    "pageMarginBottom": "10",
                    "pageMarginLeft": "10",
                    "pageMarginRight": "10",
                    "footer": true
                }
            },
            "Id": "documentSettings"
        },
        "Blocks": [
            {
                "Id": "columnsTwo-default",
                "Type": "columnsTwo",
                "Config": {
                    "Block": {
                        "col1_width": "",
                        "col1_verticalAlign": "top",
                        "col1_collapseIfEmpty": false,
                        "col2_width": "66",
                        "col2_verticalAlign": "top",
                        "col2_collapseIfEmpty": false
                    },
                    "Style": {
                        "paddingTop": "20px",
                        "paddingBottom": "20px",
                        "minHeight": "50px"
                    }
                },
                "Columns": [
                    [
                        {
                            "Id": "companyAddress-default",
                            "Type": "companyAddress",
                            "Config": {
                                "Block": {
                                    "styleCompany": "header",
                                    "colorCompany": "#434343",
                                    "fontSizeCompany": "16px",
                                    "lineHeightCompany": "22px",
                                    "styleAddress": "body",
                                    "colorAddress": "#949494",
                                    "fontSizeAddress": "12px",
                                    "lineHeightAddress": "18px"
                                },
                                "Includes": {
                                    "Company": true,
                                    "Phone": true,
                                    "Website": true
                                },
                                "Style": {
                                    "paddingBottom": "6px",
                                    "textAlign": "left"
                                }
                            }
                        }
                    ],
                    [
                        {
                            "Id": "logo-default",
                            "Type": "logo",
                            "Config": {
                                "Block": {
                                    "maxWidth": "100%",
                                    "maxHeight": "75px"
                                },
                                "Style": {
                                    "textAlign": "right"
                                }
                            }
                        }
                    ]
                ]
            },
            {
                "Id": "separator-default",
                "Type": "separator",
                "Config": {
                    "Block": {
                        "color": "#e9e9e9"
                    },
                    "Style": {
                        "paddingTop": "20px",
                        "paddingBottom": "20px"
                    }
                }
            },
            {
                "Id": "title-default",
                "Type": "title",
                "Config": {
                    "Block": {
                        "style": "header",
                        "fontSize": "18px",
                        "lineHeight": "23px"
                    },
                    "Style": {
                        "paddingTop": "20px",
                        "textAlign": "left"
                    }
                }
            },
            {
                "Id": "termDate-default",
                "Type": "termDate",
                "Config": {
                    "Block": {
                        "style": "header",
                        "fontSize": "18px",
                        "lineHeight": "23px"
                    },
                    "Style": {
                        "paddingBottom": "",
                        "textAlign": "left"
                    }
                }
            },
            {
                "Id": "address-default",
                "Type": "address",
                "Config": {
                    "Block": {
                        "style": "header",
                        "fontSize": "18px",
                        "lineHeight": "23px"
                    },
                    "Includes": {
                        "ContactName": true,
                        "SpouseName": false,
                        "Phone": true
                    },
                    "Style": {
                        "paddingBottom": "20px",
                        "textAlign": "left",
                        "paddingTop": "20px"
                    }
                }
            },
            {
                "Id": "itemContainer-default",
                "Type": "itemContainer",
                "Config": {
                    "Block": {
                        "col1_width": "100"
                    },
                    "Style": {}
                },
                "Columns": [
                    [
                        {
                            "Id": "columnsFour-default",
                            "Type": "columnsFour",
                            "Config": {
                                "Block": {
                                    "col1_width": "190px",
                                    "col1_verticalAlign": "top",
                                    "col1_collapseIfEmpty": true,
                                    "col2_width": "",
                                    "col2_verticalAlign": "top",
                                    "col2_collapseIfEmpty": false,
                                    "col3_width": "95px",
                                    "col3_verticalAlign": "top",
                                    "col3_collapseIfEmpty": true,
                                    "col4_width": "125px",
                                    "col4_verticalAlign": "top",
                                    "col4_collapseIfEmpty": true
                                },
                                "Header": {
                                    "renderHeaderOnlyFirst": true,
                                    "col1_style": "body",
                                    "col1_textAlign": "left",
                                    "col2_style": "body",
                                    "col2_textAlign": "left",
                                    "col3_style": "header",
                                    "col3_textAlign": "right",
                                    "col4_style": "header",
                                    "col4_textAlign": "right",
                                    "col4_textLabel": "Consignment Cost",
                                    "col4_fontSize": "15px",
                                    "col4_lineHeight": "19px",
                                    "col3_fontSize": "15px",
                                    "col3_lineHeight": "19px",
                                    "col3_textLabel": "Retail Price",
                                    "lineSpacing": "20px"
                                },
                                "Style": {
                                    "paddingBottom": "20px"
                                }
                            },
                            "Columns": [
                                [
                                    {
                                        "Id": "itemImage-default",
                                        "Type": "itemImage",
                                        "Config": {
                                            "Block": {
                                                "maxWidth": "163px",
                                                "maxHeight": "199px"
                                            },
                                            "Visibility": {
                                                "Image": true
                                            },
                                            "Style": {
                                                "textAlign": "center"
                                            }
                                        }
                                    }
                                ],
                                [
                                    {
                                        "Id": "itemArtist-default",
                                        "Type": "itemArtist",
                                        "Config": {
                                            "Block": {
                                                "style": "body",
                                                "fontSize": "14px",
                                                "lineHeight": "19px"
                                            },
                                            "Style": {
                                                "textAlign": "left"
                                            }
                                        }
                                    },
                                    {
                                        "Id": "itemTitle-default",
                                        "Type": "itemTitle",
                                        "Config": {
                                            "Block": {
                                                "style": "body",
                                                "fontSize": "14px",
                                                "lineHeight": "19px"
                                            },
                                            "Includes": {
                                                "Edition": true,
                                                "Date": true
                                            },
                                            "Style": {
                                                "textAlign": "left"
                                            }
                                        }
                                    },
                                    {
                                        "Id": "itemMedium-default",
                                        "Type": "itemMedium",
                                        "Config": {
                                            "Block": {
                                                "style": "body",
                                                "fontSize": "14px",
                                                "lineHeight": "19px"
                                            },
                                            "Visibility": {
                                                "Medium": true
                                            },
                                            "Style": {
                                                "textAlign": "left"
                                            }
                                        }
                                    },
                                    {
                                        "Id": "itemDimensions-default",
                                        "Type": "itemDimensions",
                                        "Config": {
                                            "Block": {
                                                "style": "body",
                                                "fontSize": "14px",
                                                "lineHeight": "19px"
                                            },
                                            "Visibility": {
                                                "Dimensions": true
                                            },
                                            "Style": {
                                                "textAlign": "left"
                                            }
                                        }
                                    },
                                    {
                                        "Id": "itemNumber-default",
                                        "Type": "itemNumber",
                                        "Config": {
                                            "Block": {
                                                "style": "body",
                                                "fontSize": "14px",
                                                "lineHeight": "19px",
                                                "textLabel": "Inventory #: "
                                            },
                                            "Visibility": {
                                                "Number": true
                                            },
                                            "Style": {
                                                "textAlign": "left"
                                            }
                                        }
                                    },
                                    {
                                        "Id": "itemSKU-default",
                                        "Type": "itemSKU",
                                        "Config": {
                                            "Block": {
                                                "style": "body",
                                                "fontSize": "14px",
                                                "lineHeight": "19px",
                                                "textLabel": "SKU: "
                                            },
                                            "Visibility": {
                                                "SKU": true
                                            },
                                            "Style": {
                                                "textAlign": "left"
                                            }
                                        }
                                    },
                                    {
                                        "Id": "itemLocation-default",
                                        "Type": "itemLocation",
                                        "Config": {
                                            "Block": {
                                                "style": "body",
                                                "fontSize": "14px",
                                                "lineHeight": "19px"
                                            },
                                            "Visibility": {
                                                "Location": true
                                            },
                                            "Style": {
                                                "textAlign": "left"
                                            }
                                        }
                                    },
                                    {
                                        "Id": "itemAcquisitionDate-default",
                                        "Type": "itemAcquisitionDate",
                                        "Config": {
                                            "Block": {
                                                "style": "body",
                                                "fontSize": "14px",
                                                "lineHeight": "19px",
                                                "textLabel": "Acquisition Date: "
                                            },
                                            "Visibility": {
                                                "AcquisitionDate": true
                                            },
                                            "Style": {
                                                "textAlign": "left"
                                            }
                                        }
                                    }
                                ],
                                [
                                    {
                                        "Id": "itemPrice-default",
                                        "Type": "itemPrice",
                                        "Config": {
                                            "Block": {
                                                "style": "body",
                                                "fontSize": "15px",
                                                "lineHeight": "19px"
                                            },
                                            "Visibility": {
                                                "Price": true
                                            },
                                            "Style": {
                                                "textAlign": "right"
                                            },
                                            "Format": {}
                                        }
                                    }
                                ],
                                [
                                    {
                                        "Id": "itemConsignmentCost-default",
                                        "Type": "itemConsignmentCost",
                                        "Config": {
                                            "Block": {
                                                "style": "body",
                                                "fontSize": "15px",
                                                "lineHeight": "19px"
                                            },
                                            "Visibility": {
                                                "ConsignmentCost": true
                                            },
                                            "Style": {
                                                "textAlign": "right"
                                            },
                                            "Format": {}
                                        }
                                    }
                                ]
                            ]
                        }
                    ]
                ]
            },
            {
                "Id": "totals-default",
                "Type": "totals",
                "Config": {
                    "Block": {
                        "displayType": "columns",
                        "styleDescription": "header",
                        "fontSizeDescription": "15px",
                        "lineHeightDescription": "19px",
                        "fontWeightDescription": "bold",
                        "textDescription": "Totals",
                        "styleLabel": "header",
                        "fontSizeLabel": "15px",
                        "lineHeightLabel": "19px",
                        "styleValue": "header",
                        "fontSizeValue": "15px",
                        "lineHeightValue": "19px",
                        "columnWidthLabel": "105px",
                        "textAlignLabel": "right",
                        "columnWidthValue": "125px",
                        "textAlignValue": "right"
                    },
                    "Includes": {
                        "RetailTotal": true,
                        "ConsignmentTotal": true
                    },
                    "Style": {
                        "textAlign": "right"
                    },
                    "Format": {
                        "currencyFormatRetail": "[CurrencySymbol]1[ThousandsSep]000[DecimalSep]00",
                        "currencyFormatConsignment": "[CurrencySymbol]1[ThousandsSep]000[DecimalSep]00"
                    }
                }
            },
            {
                "Id": "terms-default",
                "Type": "terms",
                "Config": {
                    "Block": {
                        "style": "body"
                    },
                    "Style": {
                        "textAlign": "left"
                    }
                }
            },
            {
                "Id": "columnsThree-default",
                "Type": "columnsThree",
                "Config": {
                    "Block": {
                        "col1_width": "45%",
                        "col1_verticalAlign": "top",
                        "col1_collapseIfEmpty": false,
                        "col2_width": "5%",
                        "col2_verticalAlign": "top",
                        "col2_collapseIfEmpty": false,
                        "col3_width": "45%",
                        "col3_verticalAlign": "top",
                        "col3_collapseIfEmpty": false
                    },
                    "Style": {
                        "paddingTop": "20px",
                        "paddingBottom": "20px",
                        "minHeight": "50px"
                    }
                },
                "Columns": [
                    [
                        {
                            "Id": "signature-recipient-default",
                            "Type": "signature",
                            "Config": {
                                "Block": {
                                    "signatureType": "recipient",
                                    "styleDate": "body",
                                    "fontSizeDate": "15px",
                                    "lineHeightDate": "19px",
                                    "fontStyleDate": "normal",
                                    "textTransformDate": "none",
                                    "lineSpacingDate": "4px",
                                    "styleNameLabel": "body",
                                    "fontSizeNameLabel": "15px",
                                    "lineHeightNameLabel": "19px",
                                    "fontStyleNameLabel": "normal",
                                    "textTransformNameLabel": "none",
                                    "lineSpacingNameLabel": "4px",
                                    "styleCompanyLabel": "body",
                                    "fontSizeCompanyLabel": "15px",
                                    "lineHeightCompanyLabel": "19px",
                                    "fontStyleCompanyLabel": "normal",
                                    "textTransformCompanyLabel": "none",
                                    "lineSpacingCompanyLabel": "4px",
                                    "textDateLabel": "Date",
                                    "styleDateLabel": "body",
                                    "fontSizeDateLabel": "15px",
                                    "lineHeightDateLabel": "19px",
                                    "fontStyleDateLabel": "normal",
                                    "lineSpacingDateLabel": "4px"
                                },
                                "Includes": {
                                    "DateLabel": true,
                                    "Date": true,
                                    "Company": true
                                },
                                "Style": {
                                    "paddingTop": "5px",
                                    "paddingBottom": "4px"
                                }
                            }
                        }
                    ],
                    [],
                    [
                        {
                            "Id": "signature-sender-default",
                            "Type": "signature",
                            "Config": {
                                "Block": {
                                    "signatureType": "sender",
                                    "styleDate": "body",
                                    "fontSizeDate": "15px",
                                    "lineHeightDate": "19px",
                                    "fontStyleDate": "normal",
                                    "textTransformDate": "none",
                                    "lineSpacingDate": "4px",
                                    "styleNameLabel": "body",
                                    "fontSizeNameLabel": "15px",
                                    "lineHeightNameLabel": "19px",
                                    "fontStyleNameLabel": "normal",
                                    "textTransformNameLabel": "none",
                                    "lineSpacingNameLabel": "4px",
                                    "styleCompanyLabel": "body",
                                    "fontSizeCompanyLabel": "15px",
                                    "lineHeightCompanyLabel": "19px",
                                    "fontStyleCompanyLabel": "normal",
                                    "textTransformCompanyLabel": "none",
                                    "lineSpacingCompanyLabel": "8px",
                                    "textDateLabel": "Date",
                                    "styleDateLabel": "body",
                                    "fontSizeDateLabel": "15px",
                                    "lineHeightDateLabel": "19px",
                                    "fontStyleDateLabel": "normal",
                                    "lineSpacingDateLabel": "4px"
                                },
                                "Includes": {
                                    "DateLabel": true,
                                    "Date": true,
                                    "Company": true
                                },
                                "Style": {
                                    "paddingTop": "5px",
                                    "paddingBottom": "4px"
                                }
                            }
                        }
                    ]
                ]
            }
        ]
    },
    {
        "Name": "Logo Centered",
        "IsDefault": false,
        "Type": "consignments",
        "Document": {
            "Config": {
                "Style": {
                    "paddingTop": "20px",
                    "paddingBottom": "40px",
                    "paddingLeft": "40px",
                    "paddingRight": "40px"
                },
                "PDF": {
                    "pageMarginTop": "10",
                    "pageMarginBottom": "10",
                    "pageMarginLeft": "10",
                    "pageMarginRight": "10",
                    "footer": true
                }
            },
            "Id": "documentSettings"
        },
        "Blocks": [
            {
                "Id": "logo-default",
                "Type": "logo",
                "Config": {
                    "Block": {
                        "maxWidth": "100%",
                        "maxHeight": "75px"
                    },
                    "Style": {
                        "textAlign": "center",
                        "paddingTop": "20px",
                        "paddingBottom": "20px"
                    }
                }
            },
            {
                "Id": "separator-default",
                "Type": "separator",
                "Config": {
                    "Block": {
                        "color": "#e9e9e9"
                    },
                    "Style": {
                        "paddingTop": "20px",
                        "paddingBottom": "20px"
                    }
                }
            },
            {
                "Id": "title-default",
                "Type": "title",
                "Config": {
                    "Block": {
                        "style": "header",
                        "fontSize": "18px",
                        "lineHeight": "23px"
                    },
                    "Style": {
                        "paddingTop": "20px",
                        "textAlign": "left"
                    }
                }
            },
            {
                "Id": "termDate-default",
                "Type": "termDate",
                "Config": {
                    "Block": {
                        "style": "header",
                        "fontSize": "18px",
                        "lineHeight": "23px"
                    },
                    "Style": {
                        "paddingBottom": "",
                        "textAlign": "left"
                    }
                }
            },
            {
                "Id": "address-default",
                "Type": "address",
                "Config": {
                    "Block": {
                        "style": "header",
                        "fontSize": "18px",
                        "lineHeight": "23px"
                    },
                    "Includes": {
                        "ContactName": true,
                        "SpouseName": false,
                        "Phone": true
                    },
                    "Style": {
                        "paddingBottom": "20px",
                        "textAlign": "left",
                        "paddingTop": "20px"
                    }
                }
            },
            {
                "Id": "itemContainer-default",
                "Type": "itemContainer",
                "Config": {
                    "Block": {
                        "col1_width": "100"
                    },
                    "Style": {}
                },
                "Columns": [
                    [
                        {
                            "Id": "columnsFour-default",
                            "Type": "columnsFour",
                            "Config": {
                                "Block": {
                                    "col1_width": "190px",
                                    "col1_verticalAlign": "top",
                                    "col1_collapseIfEmpty": true,
                                    "col2_width": "",
                                    "col2_verticalAlign": "top",
                                    "col2_collapseIfEmpty": false,
                                    "col3_width": "95px",
                                    "col3_verticalAlign": "top",
                                    "col3_collapseIfEmpty": true,
                                    "col4_width": "125px",
                                    "col4_verticalAlign": "top",
                                    "col4_collapseIfEmpty": true
                                },
                                "Header": {
                                    "renderHeaderOnlyFirst": true,
                                    "col1_style": "body",
                                    "col1_textAlign": "left",
                                    "col2_style": "body",
                                    "col2_textAlign": "left",
                                    "col3_style": "header",
                                    "col3_textAlign": "right",
                                    "col4_style": "header",
                                    "col4_textAlign": "right",
                                    "col4_textLabel": "Consignment Cost",
                                    "col4_fontSize": "15px",
                                    "col4_lineHeight": "19px",
                                    "col3_fontSize": "15px",
                                    "col3_lineHeight": "19px",
                                    "col3_textLabel": "Retail Price",
                                    "lineSpacing": "20px"
                                },
                                "Style": {
                                    "paddingBottom": "20px"
                                }
                            },
                            "Columns": [
                                [
                                    {
                                        "Id": "itemImage-default",
                                        "Type": "itemImage",
                                        "Config": {
                                            "Block": {
                                                "maxWidth": "163px",
                                                "maxHeight": "199px"
                                            },
                                            "Visibility": {
                                                "Image": true
                                            },
                                            "Style": {
                                                "textAlign": "center"
                                            }
                                        }
                                    }
                                ],
                                [
                                    {
                                        "Id": "itemArtist-default",
                                        "Type": "itemArtist",
                                        "Config": {
                                            "Block": {
                                                "style": "body",
                                                "fontSize": "14px",
                                                "lineHeight": "19px"
                                            },
                                            "Style": {
                                                "textAlign": "left"
                                            }
                                        }
                                    },
                                    {
                                        "Id": "itemTitle-default",
                                        "Type": "itemTitle",
                                        "Config": {
                                            "Block": {
                                                "style": "body",
                                                "fontSize": "14px",
                                                "lineHeight": "19px"
                                            },
                                            "Includes": {
                                                "Edition": true,
                                                "Date": true
                                            },
                                            "Style": {
                                                "textAlign": "left"
                                            }
                                        }
                                    },
                                    {
                                        "Id": "itemMedium-default",
                                        "Type": "itemMedium",
                                        "Config": {
                                            "Block": {
                                                "style": "body",
                                                "fontSize": "14px",
                                                "lineHeight": "19px"
                                            },
                                            "Visibility": {
                                                "Medium": true
                                            },
                                            "Style": {
                                                "textAlign": "left"
                                            }
                                        }
                                    },
                                    {
                                        "Id": "itemDimensions-default",
                                        "Type": "itemDimensions",
                                        "Config": {
                                            "Block": {
                                                "style": "body",
                                                "fontSize": "14px",
                                                "lineHeight": "19px"
                                            },
                                            "Visibility": {
                                                "Dimensions": true
                                            },
                                            "Style": {
                                                "textAlign": "left"
                                            }
                                        }
                                    },
                                    {
                                        "Id": "itemNumber-default",
                                        "Type": "itemNumber",
                                        "Config": {
                                            "Block": {
                                                "style": "body",
                                                "fontSize": "14px",
                                                "lineHeight": "19px",
                                                "textLabel": "Inventory #: "
                                            },
                                            "Visibility": {
                                                "Number": true
                                            },
                                            "Style": {
                                                "textAlign": "left"
                                            }
                                        }
                                    },
                                    {
                                        "Id": "itemSKU-default",
                                        "Type": "itemSKU",
                                        "Config": {
                                            "Block": {
                                                "style": "body",
                                                "fontSize": "14px",
                                                "lineHeight": "19px",
                                                "textLabel": "SKU: "
                                            },
                                            "Visibility": {
                                                "SKU": true
                                            },
                                            "Style": {
                                                "textAlign": "left"
                                            }
                                        }
                                    },
                                    {
                                        "Id": "itemLocation-default",
                                        "Type": "itemLocation",
                                        "Config": {
                                            "Block": {
                                                "style": "body",
                                                "fontSize": "14px",
                                                "lineHeight": "19px"
                                            },
                                            "Visibility": {
                                                "Location": true
                                            },
                                            "Style": {
                                                "textAlign": "left"
                                            }
                                        }
                                    },
                                    {
                                        "Id": "itemAcquisitionDate-default",
                                        "Type": "itemAcquisitionDate",
                                        "Config": {
                                            "Block": {
                                                "style": "body",
                                                "fontSize": "14px",
                                                "lineHeight": "19px",
                                                "textLabel": "Acquisition Date: "
                                            },
                                            "Visibility": {
                                                "AcquisitionDate": true
                                            },
                                            "Style": {
                                                "textAlign": "left"
                                            }
                                        }
                                    }
                                ],
                                [
                                    {
                                        "Id": "itemPrice-default",
                                        "Type": "itemPrice",
                                        "Config": {
                                            "Block": {
                                                "style": "body",
                                                "fontSize": "15px",
                                                "lineHeight": "19px"
                                            },
                                            "Visibility": {
                                                "Price": true
                                            },
                                            "Style": {
                                                "textAlign": "right"
                                            },
                                            "Format": {}
                                        }
                                    }
                                ],
                                [
                                    {
                                        "Id": "itemConsignmentCost-default",
                                        "Type": "itemConsignmentCost",
                                        "Config": {
                                            "Block": {
                                                "style": "body",
                                                "fontSize": "15px",
                                                "lineHeight": "19px"
                                            },
                                            "Visibility": {
                                                "ConsignmentCost": true
                                            },
                                            "Style": {
                                                "textAlign": "right"
                                            },
                                            "Format": {}
                                        }
                                    }
                                ]
                            ]
                        }
                    ]
                ]
            },
            {
                "Id": "totals-default",
                "Type": "totals",
                "Config": {
                    "Block": {
                        "displayType": "columns",
                        "styleDescription": "header",
                        "fontSizeDescription": "15px",
                        "lineHeightDescription": "19px",
                        "fontWeightDescription": "bold",
                        "textDescription": "Totals",
                        "styleLabel": "header",
                        "fontSizeLabel": "15px",
                        "lineHeightLabel": "19px",
                        "styleValue": "header",
                        "fontSizeValue": "15px",
                        "lineHeightValue": "19px",
                        "columnWidthLabel": "105px",
                        "textAlignLabel": "right",
                        "columnWidthValue": "125px",
                        "textAlignValue": "right"
                    },
                    "Includes": {
                        "RetailTotal": true,
                        "ConsignmentTotal": true
                    },
                    "Style": {
                        "textAlign": "right"
                    },
                    "Format": {
                        "currencyFormatRetail": "[CurrencySymbol]1[ThousandsSep]000[DecimalSep]00",
                        "currencyFormatConsignment": "[CurrencySymbol]1[ThousandsSep]000[DecimalSep]00"
                    }
                }
            },
            {
                "Id": "terms-default",
                "Type": "terms",
                "Config": {
                    "Block": {
                        "style": "body"
                    },
                    "Style": {
                        "textAlign": "left"
                    }
                }
            },
            {
                "Id": "columnsThree-default",
                "Type": "columnsThree",
                "Config": {
                    "Block": {
                        "col1_width": "45%",
                        "col1_verticalAlign": "top",
                        "col1_collapseIfEmpty": false,
                        "col2_width": "5%",
                        "col2_verticalAlign": "top",
                        "col2_collapseIfEmpty": false,
                        "col3_width": "45%",
                        "col3_verticalAlign": "top",
                        "col3_collapseIfEmpty": false
                    },
                    "Style": {
                        "paddingTop": "20px",
                        "paddingBottom": "20px",
                        "minHeight": "50px"
                    }
                },
                "Columns": [
                    [
                        {
                            "Id": "signature-recipient-default",
                            "Type": "signature",
                            "Config": {
                                "Block": {
                                    "signatureType": "recipient",
                                    "styleDate": "body",
                                    "fontSizeDate": "15px",
                                    "lineHeightDate": "19px",
                                    "fontStyleDate": "normal",
                                    "textTransformDate": "none",
                                    "lineSpacingDate": "4px",
                                    "styleNameLabel": "body",
                                    "fontSizeNameLabel": "15px",
                                    "lineHeightNameLabel": "19px",
                                    "fontStyleNameLabel": "normal",
                                    "textTransformNameLabel": "none",
                                    "lineSpacingNameLabel": "4px",
                                    "styleCompanyLabel": "body",
                                    "fontSizeCompanyLabel": "15px",
                                    "lineHeightCompanyLabel": "19px",
                                    "fontStyleCompanyLabel": "normal",
                                    "textTransformCompanyLabel": "none",
                                    "lineSpacingCompanyLabel": "4px",
                                    "textDateLabel": "Date",
                                    "styleDateLabel": "body",
                                    "fontSizeDateLabel": "15px",
                                    "lineHeightDateLabel": "19px",
                                    "fontStyleDateLabel": "normal",
                                    "lineSpacingDateLabel": "4px"
                                },
                                "Includes": {
                                    "DateLabel": true,
                                    "Date": true,
                                    "Company": true
                                },
                                "Style": {
                                    "paddingTop": "5px",
                                    "paddingBottom": "4px"
                                }
                            }
                        }
                    ],
                    [],
                    [
                        {
                            "Id": "signature-sender-default",
                            "Type": "signature",
                            "Config": {
                                "Block": {
                                    "signatureType": "sender",
                                    "styleDate": "body",
                                    "fontSizeDate": "15px",
                                    "lineHeightDate": "19px",
                                    "fontStyleDate": "normal",
                                    "textTransformDate": "none",
                                    "lineSpacingDate": "4px",
                                    "styleNameLabel": "body",
                                    "fontSizeNameLabel": "15px",
                                    "lineHeightNameLabel": "19px",
                                    "fontStyleNameLabel": "normal",
                                    "textTransformNameLabel": "none",
                                    "lineSpacingNameLabel": "4px",
                                    "styleCompanyLabel": "body",
                                    "fontSizeCompanyLabel": "15px",
                                    "lineHeightCompanyLabel": "19px",
                                    "fontStyleCompanyLabel": "normal",
                                    "textTransformCompanyLabel": "none",
                                    "lineSpacingCompanyLabel": "8px",
                                    "textDateLabel": "Date",
                                    "styleDateLabel": "body",
                                    "fontSizeDateLabel": "15px",
                                    "lineHeightDateLabel": "19px",
                                    "fontStyleDateLabel": "normal",
                                    "lineSpacingDateLabel": "4px"
                                },
                                "Includes": {
                                    "DateLabel": true,
                                    "Date": true,
                                    "Company": true
                                },
                                "Style": {
                                    "paddingTop": "5px",
                                    "paddingBottom": "4px"
                                }
                            }
                        }
                    ]
                ]
            }
        ]
    },
    {
        "Name": "Classic",
        "IsDefault": false,
        "Type": "consignments",
        "Document": {
            "Config": {
                "Style": {
                    "paddingTop": "0px",
                    "paddingBottom": "8px",
                    "paddingLeft": "8px",
                    "paddingRight": "8px"
                },
                "PDF": {
                    "pageMarginTop": "10",
                    "pageMarginBottom": "10",
                    "pageMarginLeft": "10",
                    "pageMarginRight": "10",
                    "footer": true
                }
            },
            "Id": "documentSettings"
        },
        "Blocks": [
            {
                "Id": "logo-default",
                "Type": "logo",
                "Config": {
                    "Block": {
                        "maxWidth": "200px",
                        "maxHeight": "150px"
                    },
                    "Style": {
                        "textAlign": "center",
                        "paddingTop": "",
                        "paddingBottom": "40px"
                    }
                }
            },
            {
                "Id": "title-default",
                "Type": "title",
                "Config": {
                    "Block": {
                        "style": "body",
                        "fontSize": "16px",
                        "lineHeight": ""
                    },
                    "Style": {
                        "paddingTop": "10px",
                        "textAlign": "center",
                        "paddingBottom": ""
                    }
                }
            },
            {
                "Id": "termDate-default",
                "Type": "termDate",
                "Config": {
                    "Block": {
                        "style": "body",
                        "fontSize": "16px",
                        "lineHeight": ""
                    },
                    "Style": {
                        "paddingBottom": "",
                        "textAlign": "center",
                        "paddingTop": ""
                    }
                }
            },
            {
                "Id": "itemContainer-default",
                "Type": "itemContainer",
                "Config": {
                    "Block": {
                        "col1_width": "100"
                    },
                    "Style": {
                        "paddingTop": ""
                    }
                },
                "Columns": [
                    [
                        {
                            "Id": "columnsFour-default",
                            "Type": "columnsFour",
                            "Config": {
                                "Block": {
                                    "col1_width": "20%",
                                    "col1_verticalAlign": "middle",
                                    "col1_collapseIfEmpty": true,
                                    "col2_width": "",
                                    "col2_verticalAlign": "middle",
                                    "col2_collapseIfEmpty": false,
                                    "col3_width": "20%",
                                    "col3_verticalAlign": "middle",
                                    "col3_collapseIfEmpty": true,
                                    "col4_width": "20%",
                                    "col4_verticalAlign": "middle",
                                    "col4_collapseIfEmpty": true,
                                    "col4_paddingRight": "10px",
                                    "col3_paddingRight": "10px",
                                    "col1_paddingLeft": "10px",
                                    "col1_paddingRight": "10px",
                                    "col2_paddingLeft": "10px",
                                    "col2_paddingRight": "10px",
                                    "col3_paddingLeft": "10px",
                                    "col4_paddingLeft": "10px",
                                    "borderTopSpacing": "",
                                    "col1_paddingTop": "10px",
                                    "col1_paddingBottom": "10px",
                                    "col2_paddingTop": "10px",
                                    "col2_paddingBottom": "10px",
                                    "col3_paddingTop": "10px",
                                    "col3_paddingBottom": "10px",
                                    "col4_paddingTop": "10px",
                                    "col4_paddingBottom": "10px"
                                },
                                "Header": {
                                    "renderHeaderOnlyFirst": true,
                                    "col1_style": "body",
                                    "col1_textAlign": "left",
                                    "col2_style": "body",
                                    "col2_textAlign": "left",
                                    "col3_style": "body",
                                    "col3_textAlign": "right",
                                    "col4_style": "body",
                                    "col4_textAlign": "right",
                                    "col4_textLabel": "Consignment Cost",
                                    "col4_fontSize": "16px",
                                    "col4_lineHeight": "",
                                    "col3_fontSize": "16px",
                                    "col3_lineHeight": "",
                                    "col3_textLabel": "Retail Price",
                                    "lineSpacing": "",
                                    "paddingTop": "20px",
                                    "paddingBottom": "10px",
                                    "col3_paddingRight": "10px",
                                    "col4_paddingRight": "10px",
                                    "col4_paddingLeft": "10px",
                                    "col3_paddingLeft": "10px",
                                    "col1_paddingLeft": "10px",
                                    "col1_paddingRight": "10px",
                                    "col2_paddingLeft": "10px",
                                    "col2_paddingRight": "10px"
                                },
                                "Style": {
                                    "paddingBottom": "",
                                    "paddingLeft": "",
                                    "paddingRight": "",
                                    "minHeight": ""
                                }
                            },
                            "Columns": [
                                [
                                    {
                                        "Id": "itemImage-default",
                                        "Type": "itemImage",
                                        "Config": {
                                            "Block": {
                                                "maxWidth": "100%",
                                                "maxHeight": ""
                                            },
                                            "Visibility": {
                                                "Image": true
                                            },
                                            "Style": {
                                                "textAlign": "center",
                                                "paddingBottom": "",
                                                "paddingTop": ""
                                            }
                                        }
                                    }
                                ],
                                [
                                    {
                                        "Id": "itemArtist-default",
                                        "Type": "itemArtist",
                                        "Config": {
                                            "Block": {
                                                "style": "body",
                                                "fontSize": "16px",
                                                "lineHeight": "",
                                                "fontWeight": "bold"
                                            },
                                            "Style": {
                                                "textAlign": "left"
                                            }
                                        }
                                    },
                                    {
                                        "Id": "itemTitle-default",
                                        "Type": "itemTitle",
                                        "Config": {
                                            "Block": {
                                                "style": "body",
                                                "fontSize": "16px",
                                                "lineHeight": ""
                                            },
                                            "Includes": {
                                                "Edition": true,
                                                "Date": true
                                            },
                                            "Style": {
                                                "textAlign": "left"
                                            }
                                        }
                                    },
                                    {
                                        "Id": "itemMedium-default",
                                        "Type": "itemMedium",
                                        "Config": {
                                            "Block": {
                                                "style": "body",
                                                "fontSize": "16px",
                                                "lineHeight": ""
                                            },
                                            "Visibility": {
                                                "Medium": true
                                            },
                                            "Style": {
                                                "textAlign": "left"
                                            }
                                        }
                                    },
                                    {
                                        "Id": "itemDimensions-default",
                                        "Type": "itemDimensions",
                                        "Config": {
                                            "Block": {
                                                "style": "body",
                                                "fontSize": "16px",
                                                "lineHeight": ""
                                            },
                                            "Visibility": {
                                                "Dimensions": true
                                            },
                                            "Style": {
                                                "textAlign": "left"
                                            }
                                        }
                                    },
                                    {
                                        "Id": "itemNumber-default",
                                        "Type": "itemNumber",
                                        "Config": {
                                            "Block": {
                                                "style": "body",
                                                "fontSize": "16px",
                                                "lineHeight": "",
                                                "textLabel": "Inventory #: "
                                            },
                                            "Visibility": {
                                                "Number": true
                                            },
                                            "Style": {
                                                "textAlign": "left"
                                            }
                                        }
                                    },
                                    {
                                        "Id": "itemSKU-default",
                                        "Type": "itemSKU",
                                        "Config": {
                                            "Block": {
                                                "style": "body",
                                                "fontSize": "16px",
                                                "lineHeight": "",
                                                "textLabel": "SKU: "
                                            },
                                            "Visibility": {
                                                "SKU": true
                                            },
                                            "Style": {
                                                "textAlign": "left"
                                            }
                                        }
                                    },
                                    {
                                        "Id": "itemLocation-default",
                                        "Type": "itemLocation",
                                        "Config": {
                                            "Block": {
                                                "style": "body",
                                                "fontSize": "16px",
                                                "lineHeight": ""
                                            },
                                            "Visibility": {
                                                "Location": true
                                            },
                                            "Style": {
                                                "textAlign": "left"
                                            }
                                        }
                                    },
                                    {
                                        "Id": "itemAcquisitionDate-default",
                                        "Type": "itemAcquisitionDate",
                                        "Config": {
                                            "Block": {
                                                "textLabel": "Acquisition Date: ",
                                                "style": "body",
                                                "fontSize": "16px",
                                                "lineHeight": "",
                                                "fontStyle": "normal"
                                            },
                                            "Visibility": {
                                                "AcquisitionDate": true
                                            },
                                            "Style": {
                                                "textAlign": "left"
                                            }
                                        }
                                    }
                                ],
                                [
                                    {
                                        "Id": "itemPrice-default",
                                        "Type": "itemPrice",
                                        "Config": {
                                            "Block": {
                                                "style": "body",
                                                "fontSize": "16px",
                                                "lineHeight": ""
                                            },
                                            "Visibility": {
                                                "Price": true
                                            },
                                            "Style": {
                                                "textAlign": "right",
                                                "paddingRight": ""
                                            },
                                            "Format": {
                                                "currencyFormatFirst": "[CurrencySymbol]1[ThousandsSep]000[DecimalSep]00",
                                                "currencyFormat": "[CurrencySymbol]1[ThousandsSep]000[DecimalSep]00"
                                            }
                                        }
                                    }
                                ],
                                [
                                    {
                                        "Id": "itemConsignmentCost-default",
                                        "Type": "itemConsignmentCost",
                                        "Config": {
                                            "Block": {
                                                "style": "body",
                                                "fontSize": "16px",
                                                "lineHeight": ""
                                            },
                                            "Visibility": {
                                                "ConsignmentCost": true
                                            },
                                            "Style": {
                                                "textAlign": "right",
                                                "paddingRight": ""
                                            },
                                            "Format": {
                                                "currencyFormatFirst": "[CurrencySymbol]1[ThousandsSep]000[DecimalSep]00",
                                                "currencyFormat": "[CurrencySymbol]1[ThousandsSep]000[DecimalSep]00"
                                            }
                                        }
                                    }
                                ]
                            ]
                        }
                    ]
                ]
            },
            {
                "Id": "totals-default",
                "Type": "totals",
                "Config": {
                    "Block": {
                        "displayType": "columns",
                        "styleDescription": "header",
                        "fontSizeDescription": "15px",
                        "lineHeightDescription": "",
                        "fontWeightDescription": "bold",
                        "textDescription": "",
                        "styleLabel": "body",
                        "fontSizeLabel": "16px",
                        "lineHeightLabel": "",
                        "styleValue": "body",
                        "fontSizeValue": "16px",
                        "lineHeightValue": "",
                        "columnWidthLabel": "20%",
                        "textAlignLabel": "right",
                        "columnWidthValue": "20%",
                        "textAlignValue": "right",
                        "paddingRightLabel": "10px",
                        "paddingRightDescription": "",
                        "paddingRightValue": "10px"
                    },
                    "Includes": {
                        "RetailTotal": true,
                        "ConsignmentTotal": true
                    },
                    "Style": {
                        "textAlign": "right",
                        "paddingRight": "",
                        "paddingBottom": "10px",
                        "paddingTop": "10px"
                    },
                    "Format": {
                        "currencyFormatRetail": "[CurrencySymbol]1[ThousandsSep]000[DecimalSep]00",
                        "currencyFormatConsignment": "[CurrencySymbol]1[ThousandsSep]000[DecimalSep]00"
                    }
                }
            },
            {
                "Id": "terms-default",
                "Type": "terms",
                "Config": {
                    "Block": {
                        "style": "body"
                    },
                    "Style": {
                        "paddingTop": "10px",
                        "paddingBottom": "10px",
                        "textAlign": "left",
                        "paddingLeft": "10px",
                        "paddingRight": "10px"
                    }
                }
            },
            {
                "Id": "columnsThree-default",
                "Type": "columnsThree",
                "Config": {
                    "Block": {
                        "col1_width": "45%",
                        "col1_verticalAlign": "top",
                        "col1_collapseIfEmpty": false,
                        "col2_width": "5%",
                        "col2_verticalAlign": "top",
                        "col2_collapseIfEmpty": false,
                        "col3_width": "45%",
                        "col3_verticalAlign": "top",
                        "col3_collapseIfEmpty": false
                    },
                    "Style": {
                        "paddingTop": "20px",
                        "paddingBottom": "20px",
                        "minHeight": "50px"
                    }
                },
                "Columns": [
                    [
                        {
                            "Id": "signature-recipient-default",
                            "Type": "signature",
                            "Config": {
                                "Block": {
                                    "signatureType": "recipient",
                                    "styleDate": "body",
                                    "fontSizeDate": "15px",
                                    "lineHeightDate": "19px",
                                    "fontStyleDate": "normal",
                                    "textTransformDate": "none",
                                    "lineSpacingDate": "4px",
                                    "styleNameLabel": "body",
                                    "fontSizeNameLabel": "15px",
                                    "lineHeightNameLabel": "19px",
                                    "fontStyleNameLabel": "normal",
                                    "textTransformNameLabel": "none",
                                    "lineSpacingNameLabel": "4px",
                                    "styleCompanyLabel": "body",
                                    "fontSizeCompanyLabel": "15px",
                                    "lineHeightCompanyLabel": "19px",
                                    "fontStyleCompanyLabel": "normal",
                                    "textTransformCompanyLabel": "none",
                                    "lineSpacingCompanyLabel": "4px",
                                    "textDateLabel": "Date",
                                    "styleDateLabel": "body",
                                    "fontSizeDateLabel": "15px",
                                    "lineHeightDateLabel": "19px",
                                    "fontStyleDateLabel": "normal",
                                    "lineSpacingDateLabel": "4px"
                                },
                                "Includes": {
                                    "DateLabel": true,
                                    "Date": true,
                                    "Company": true
                                },
                                "Style": {
                                    "paddingTop": "4px",
                                    "paddingBottom": "4px"
                                }
                            }
                        }
                    ],
                    [],
                    [
                        {
                            "Id": "signature-sender-default",
                            "Type": "signature",
                            "Config": {
                                "Block": {
                                    "signatureType": "sender",
                                    "styleDate": "body",
                                    "fontSizeDate": "15px",
                                    "lineHeightDate": "19px",
                                    "fontStyleDate": "normal",
                                    "textTransformDate": "none",
                                    "lineSpacingDate": "4px",
                                    "styleNameLabel": "body",
                                    "fontSizeNameLabel": "15px",
                                    "lineHeightNameLabel": "19px",
                                    "fontStyleNameLabel": "normal",
                                    "textTransformNameLabel": "none",
                                    "lineSpacingNameLabel": "4px",
                                    "styleCompanyLabel": "body",
                                    "fontSizeCompanyLabel": "15px",
                                    "lineHeightCompanyLabel": "19px",
                                    "fontStyleCompanyLabel": "normal",
                                    "textTransformCompanyLabel": "none",
                                    "lineSpacingCompanyLabel": "8px",
                                    "textDateLabel": "Date",
                                    "styleDateLabel": "body",
                                    "fontSizeDateLabel": "15px",
                                    "lineHeightDateLabel": "19px",
                                    "fontStyleDateLabel": "normal",
                                    "lineSpacingDateLabel": "4px"
                                },
                                "Includes": {
                                    "DateLabel": true,
                                    "Date": true,
                                    "Company": true
                                },
                                "Style": {
                                    "paddingTop": "4px",
                                    "paddingBottom": "4px"
                                }
                            }
                        }
                    ]
                ]
            }
        ]
    },
    /*
    {
        "Name": "Contemporary",
        "IsDefault": false,
        "Type": "consignments",
        "Document": {
            "Config": {
                "Style": {
                    "paddingTop": "20px",
                    "paddingBottom": "40px",
                    "paddingLeft": "40px",
                    "paddingRight": "40px"
                },
                "PDF": {
                    "pageMarginTop": "10",
                    "pageMarginBottom": "10",
                    "pageMarginLeft": "10",
                    "pageMarginRight": "10",
                    "footer": true
                }
            },
            "Id": "documentSettings"
        },
        "Blocks": [
            {
                "Id": "logo-default",
                "Type": "logo",
                "Config": {
                    "Block": {
                        "maxWidth": "430px",
                        "maxHeight": ""
                    },
                    "Style": {
                        "textAlign": "center",
                        "paddingTop": "20px",
                        "paddingBottom": "40px"
                    }
                }
            },
            {
                "Id": "termDate-default",
                "Type": "termDate",
                "Config": {
                    "Block": {
                        "style": "header",
                        "fontSize": "18px",
                        "lineHeight": "23px"
                    },
                    "Style": {
                        "paddingBottom": "",
                        "textAlign": "left",
                        "paddingTop": ""
                    }
                }
            },
            {
                "Id": "title-default",
                "Type": "title",
                "Config": {
                    "Block": {
                        "style": "header",
                        "fontSize": "18px",
                        "lineHeight": "23px",
                        "textTransform": "uppercase"
                    },
                    "Style": {
                        "paddingTop": "80px",
                        "textAlign": "left",
                        "paddingBottom": "20px"
                    }
                }
            },
            {
                "Id": "address-default",
                "Type": "address",
                "Config": {
                    "Block": {
                        "style": "header",
                        "fontSize": "18px",
                        "lineHeight": "23px"
                    },
                    "Includes": {
                        "ContactName": true,
                        "SpouseName": true,
                        "Phone": true
                    },
                    "Style": {
                        "paddingBottom": "20px",
                        "textAlign": "left"
                    }
                }
            },
            {
                "Id": "itemContainer-default",
                "Type": "itemContainer",
                "Config": {
                    "Block": {
                        "col1_width": "100"
                    },
                    "Style": {
                        "paddingTop": ""
                    }
                },
                "Columns": [
                    [
                        {
                            "Id": "columnsFour-default",
                            "Type": "columnsFour",
                            "Config": {
                                "Block": {
                                    "col1_width": "190px",
                                    "col1_verticalAlign": "top",
                                    "col1_collapseIfEmpty": true,
                                    "col2_width": "",
                                    "col2_verticalAlign": "top",
                                    "col2_collapseIfEmpty": false,
                                    "col3_width": "95px",
                                    "col3_verticalAlign": "top",
                                    "col3_collapseIfEmpty": true,
                                    "col4_width": "95px",
                                    "col4_verticalAlign": "top",
                                    "col4_collapseIfEmpty": true,
                                    "col4_paddingRight": "",
                                    "col3_paddingRight": "",
                                    "col1_paddingLeft": "",
                                    "col1_paddingRight": "",
                                    "col2_paddingLeft": "",
                                    "col2_paddingRight": "",
                                    "col3_paddingLeft": "",
                                    "col4_paddingLeft": "",
                                    "borderTopSpacing": "",
                                    "col1_paddingTop": "",
                                    "col1_paddingBottom": "",
                                    "col2_paddingTop": "",
                                    "col2_paddingBottom": "",
                                    "col3_paddingTop": "",
                                    "col3_paddingBottom": "",
                                    "col4_paddingTop": "",
                                    "col4_paddingBottom": ""
                                },
                                "Header": {
                                    "renderHeaderOnlyFirst": true,
                                    "col1_style": "body",
                                    "col1_textAlign": "left",
                                    "col2_style": "body",
                                    "col2_textAlign": "left",
                                    "col3_style": "header",
                                    "col3_textAlign": "right",
                                    "col4_style": "header",
                                    "col4_textAlign": "right",
                                    "col4_textLabel": "Consignment Cost",
                                    "col4_fontSize": "15px",
                                    "col4_lineHeight": "19px",
                                    "col3_fontSize": "15px",
                                    "col3_lineHeight": "19px",
                                    "col3_textLabel": "Price",
                                    "lineSpacing": "",
                                    "paddingTop": "",
                                    "paddingBottom": "20px",
                                    "col3_paddingRight": "",
                                    "col4_paddingRight": "",
                                    "col4_paddingLeft": "",
                                    "col3_paddingLeft": "",
                                    "col3_verticalAlign": "top",
                                    "col4_verticalAlign": "top"
                                },
                                "Style": {
                                    "paddingBottom": "20px",
                                    "paddingLeft": "",
                                    "paddingRight": "",
                                    "minHeight": ""
                                }
                            },
                            "Columns": [
                                [
                                    {
                                        "Id": "itemImage-default",
                                        "Type": "itemImage",
                                        "Config": {
                                            "Block": {
                                                "maxWidth": "163px",
                                                "maxHeight": "199px"
                                            },
                                            "Visibility": {
                                                "Image": true
                                            },
                                            "Style": {
                                                "textAlign": "center",
                                                "paddingBottom": ""
                                            }
                                        }
                                    }
                                ],
                                [
                                    {
                                        "Id": "itemArtist-default",
                                        "Type": "itemArtist",
                                        "Config": {
                                            "Block": {
                                                "style": "body",
                                                "fontSize": "14px",
                                                "lineHeight": "18px",
                                                "fontWeight": ""
                                            },
                                            "Style": {
                                                "textAlign": "left"
                                            }
                                        }
                                    },
                                    {
                                        "Id": "itemTitle-default",
                                        "Type": "itemTitle",
                                        "Config": {
                                            "Block": {
                                                "style": "body",
                                                "fontSize": "14px",
                                                "lineHeight": "18px"
                                            },
                                            "Includes": {
                                                "Edition": true,
                                                "Date": true
                                            },
                                            "Style": {
                                                "textAlign": "left"
                                            }
                                        }
                                    },
                                    {
                                        "Id": "itemMedium-default",
                                        "Type": "itemMedium",
                                        "Config": {
                                            "Block": {
                                                "style": "body",
                                                "fontSize": "14px",
                                                "lineHeight": "18px"
                                            },
                                            "Visibility": {
                                                "Medium": true
                                            },
                                            "Style": {
                                                "textAlign": "left"
                                            }
                                        }
                                    },
                                    {
                                        "Id": "itemDimensions-default",
                                        "Type": "itemDimensions",
                                        "Config": {
                                            "Block": {
                                                "style": "body",
                                                "fontSize": "14px",
                                                "lineHeight": "18px"
                                            },
                                            "Visibility": {
                                                "Dimensions": true
                                            },
                                            "Style": {
                                                "textAlign": "left"
                                            }
                                        }
                                    },
                                    {
                                        "Id": "itemNumber-default",
                                        "Type": "itemNumber",
                                        "Config": {
                                            "Block": {
                                                "style": "body",
                                                "fontSize": "14px",
                                                "lineHeight": "18px",
                                                "textLabel": "Inventory #: "
                                            },
                                            "Visibility": {
                                                "Number": true
                                            },
                                            "Style": {
                                                "textAlign": "left"
                                            }
                                        }
                                    },
                                    {
                                        "Id": "itemSKU-default",
                                        "Type": "itemSKU",
                                        "Config": {
                                            "Block": {
                                                "style": "body",
                                                "fontSize": "14px",
                                                "lineHeight": "18px",
                                                "textLabel": "SKU: "
                                            },
                                            "Visibility": {
                                                "SKU": true
                                            },
                                            "Style": {
                                                "textAlign": "left"
                                            }
                                        }
                                    },
                                    {
                                        "Id": "itemLocation-default",
                                        "Type": "itemLocation",
                                        "Config": {
                                            "Block": {
                                                "style": "body",
                                                "fontSize": "14px",
                                                "lineHeight": "18px"
                                            },
                                            "Visibility": {
                                                "Location": true
                                            },
                                            "Style": {
                                                "textAlign": "left"
                                            }
                                        }
                                    },
                                    {
                                        "Id": "itemAcquisitionDate-default",
                                        "Type": "itemAcquisitionDate",
                                        "Config": {
                                            "Block": {
                                                "textLabel": "Acquisition Date: ",
                                                "style": "body",
                                                "fontSize": "14px",
                                                "lineHeight": "18px",
                                                "fontStyle": "normal"
                                            },
                                            "Visibility": {
                                                "AcquisitionDate": true
                                            },
                                            "Style": {
                                                "textAlign": "left"
                                            }
                                        }
                                    }
                                ],
                                [
                                    {
                                        "Id": "itemPrice-default",
                                        "Type": "itemPrice",
                                        "Config": {
                                            "Block": {
                                                "style": "body",
                                                "fontSize": "15px",
                                                "lineHeight": "19px"
                                            },
                                            "Visibility": {
                                                "Price": true
                                            },
                                            "Style": {
                                                "textAlign": "right",
                                                "paddingRight": ""
                                            },
                                            "Format": {
                                                "currencyFormatFirst": "[CurrencySymbol]  1[ThousandsSep]000",
                                                "currencyFormat": "1[ThousandsSep]000"
                                            }
                                        }
                                    }
                                ],
                                [
                                    {
                                        "Id": "itemConsignmentCost-default",
                                        "Type": "itemConsignmentCost",
                                        "Config": {
                                            "Block": {
                                                "style": "body",
                                                "fontSize": "15px",
                                                "lineHeight": "19px"
                                            },
                                            "Visibility": {
                                                "ConsignmentCost": true
                                            },
                                            "Style": {
                                                "textAlign": "right",
                                                "paddingRight": ""
                                            },
                                            "Format": {
                                                "currencyFormatFirst": "[CurrencySymbol]  1[ThousandsSep]000",
                                                "currencyFormat": "1[ThousandsSep]000"
                                            }
                                        }
                                    }
                                ]
                            ]
                        }
                    ]
                ]
            },
            {
                "Id": "terms-default",
                "Type": "terms",
                "Config": {
                    "Block": {
                        "style": "body"
                    },
                    "Style": {
                        "textAlign": "left"
                    }
                }
            },
            {
                "Id": "columnsThree-default",
                "Type": "columnsThree",
                "Config": {
                    "Block": {
                        "col1_width": "45%",
                        "col1_verticalAlign": "top",
                        "col1_collapseIfEmpty": false,
                        "col2_width": "5%",
                        "col2_verticalAlign": "top",
                        "col2_collapseIfEmpty": false,
                        "col3_width": "45%",
                        "col3_verticalAlign": "top",
                        "col3_collapseIfEmpty": false
                    },
                    "Style": {
                        "paddingTop": "20px",
                        "paddingBottom": "20px",
                        "minHeight": "36px"
                    }
                },
                "Columns": [
                    [
                        {
                            "Id": "signature-recipient-default",
                            "Type": "signature",
                            "Config": {
                                "Block": {
                                    "signatureType": "recipient",
                                    "styleDate": "body",
                                    "fontSizeDate": "15px",
                                    "lineHeightDate": "19px",
                                    "fontStyleDate": "normal",
                                    "textTransformDate": "none",
                                    "lineSpacingDate": "4px",
                                    "styleNameLabel": "body",
                                    "fontSizeNameLabel": "15px",
                                    "lineHeightNameLabel": "19px",
                                    "fontStyleNameLabel": "normal",
                                    "textTransformNameLabel": "none",
                                    "lineSpacingNameLabel": "4px",
                                    "styleCompanyLabel": "body",
                                    "fontSizeCompanyLabel": "15px",
                                    "lineHeightCompanyLabel": "19px",
                                    "fontStyleCompanyLabel": "normal",
                                    "textTransformCompanyLabel": "none",
                                    "lineSpacingCompanyLabel": "4px",
                                    "textDateLabel": "Date",
                                    "styleDateLabel": "body",
                                    "fontSizeDateLabel": "15px",
                                    "lineHeightDateLabel": "19px",
                                    "fontStyleDateLabel": "normal",
                                    "lineSpacingDateLabel": "4px"
                                },
                                "Includes": {
                                    "DateLabel": true,
                                    "Date": false,
                                    "Company": true
                                },
                                "Style": {
                                    "paddingTop": "8px"
                                }
                            }
                        }
                    ],
                    [],
                    [
                        {
                            "Id": "signature-sender-default",
                            "Type": "signature",
                            "Config": {
                                "Block": {
                                    "signatureType": "sender",
                                    "styleDate": "body",
                                    "fontSizeDate": "15px",
                                    "lineHeightDate": "19px",
                                    "fontStyleDate": "normal",
                                    "textTransformDate": "none",
                                    "lineSpacingDate": "4px",
                                    "styleNameLabel": "body",
                                    "fontSizeNameLabel": "15px",
                                    "lineHeightNameLabel": "19px",
                                    "fontStyleNameLabel": "normal",
                                    "textTransformNameLabel": "none",
                                    "lineSpacingNameLabel": "4px",
                                    "styleCompanyLabel": "body",
                                    "fontSizeCompanyLabel": "15px",
                                    "lineHeightCompanyLabel": "19px",
                                    "fontStyleCompanyLabel": "normal",
                                    "textTransformCompanyLabel": "none",
                                    "lineSpacingCompanyLabel": "8px",
                                    "textDateLabel": "Date",
                                    "styleDateLabel": "body",
                                    "fontSizeDateLabel": "15px",
                                    "lineHeightDateLabel": "19px",
                                    "fontStyleDateLabel": "normal",
                                    "lineSpacingDateLabel": "4px"
                                },
                                "Includes": {
                                    "DateLabel": true,
                                    "Date": false,
                                    "Company": true
                                },
                                "Style": {
                                    "paddingTop": "8px"
                                }
                            }
                        }
                    ]
                ]
            }
        ]
    }
    */
];

module.exports = Templates;